module.exports = __webpack_public_path__ + "static/media/israr.638147c2.png";